import React, { FC, ReactElement } from 'react'
import ButtonGradientEpic from '@/components/button-gradient-epic'
import classNames from 'classnames'
import { DISCORD_INVITE } from '@/utils/constants'

import DiscordIcon from '@/icons/discord'
import styles from './JoinDiscordButton.module.css'

const JoinDiscordButton: FC<{
	className?: string
	label?: string
	buttonClassName?: string
	iconClassName?: string
}> = (props): ReactElement => {
	return (
		<a
			className={classNames(styles.root, { [(props.className as any)]: !!props.className })}
			target="_blank"
			href={DISCORD_INVITE}
		>
			<ButtonGradientEpic
				className={classNames(styles.button, { [(props.buttonClassName as any)]: !!props.buttonClassName })}
			>
				<DiscordIcon
					className={classNames(styles.icon, { [(props.iconClassName as any)]: !!props.iconClassName })}
				/>
				{props.label || 'Join Discord!'}
			</ButtonGradientEpic>
		</a>
	)
}

export default JoinDiscordButton
